import { DialogProps } from "@mui/material";
import { MouseEventHandler, ReactNode } from "react";

export interface ILoginFormData {
  email: string;
  password: string;
}

export interface IRegisterFormData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  phoneNumber: string;
}

export interface IRegisterFormWithConfirm extends IRegisterFormData {
  confirmPassword: string;
}

export interface IResetPasswordFormData {
  password: string;
  confirmPassword: string;
}

export interface IQuoteFormData {
  customer_guid: string;
  receive_amount: number;
  symbol: string;
}

export interface IMainOptions {
  option: 
    {title: 'Wrap Box', src: '../images/demo-pics/gyrosa_mains_wrapbox1.jpg'} | 
    {title: 'Meal Box', src: '../images/demo-pics/gyrosa_mains_mealbox1.jpg'}
}

export interface IProteinOptions {
  option:
    {title: 'Chicken Gyro', src: '../images/demo-pics/gyrosa_protein_chicken.jpg'} | 
    {title: 'Beef & Lamb Gyro', src: '../images/demo-pics/gyrosa_protein_beef+lamb.jpg'} | 
    {title: 'Chicken Souvlaki', src: '../images/demo-pics/gyrosa_protein_chicken_souvlaki.jpg'} | 
    {title: 'Crispy Chicken', src: '../images/demo-pics/gyrosa_protein_cripsy_souvlaki.jpg'} | 
    {title: 'Shrimp Souvlaki', src: '../images/demo-pics/gyrosa_protein_shrimp_souvlaki.jpg'} | 
    {title: 'Falafel', src: '../images/demo-pics/gyrosa_protein_falafel.jpg'} 
}

export interface ISideOptions {
  option:
    {title: 'Fries', src: '../images/demo-pics/gyrosa_sides_fries.jpg'} | 
    {title: 'Greek Salad', src: '../images/demo-pics/gyrosa_sides_salad_greeksalad.jpg'} | 
    {title: 'Kale Ceasar Salad', src: '../images/demo-pics/gyrosa_sides_salad_kale_caesar.jpg'} | 
    {title: 'Feta Fries', src: '../images/demo-pics/gyrosa_sides_feta_fries.jpg'} | 
    {title: 'Garlic Feta Fries', src: '../images/demo-pics/gyrosa_sides_garlic_feta_fries.jpg'} | 
    {title: 'Rice', src: '../images/demo-pics/gyrosa_sides_rice.jpg'} | 
    {title: 'Pita', src: '../images/demo-pics/gyrosa_sides_pita&hummusjpg.jpg'}
}

export interface ISelectedMealItems {
  main: IMainOptions | null
  protein: IProteinOptions | null,
  sides: [ISideOptions] | []
}

export interface ExtendedDialogProps extends DialogProps {
  dialogTitle: string | ReactNode;
  dialogSubtitle?: string | ReactNode;
  titleBar?: string;
  children: ReactNode | ReactNode[];
}

export interface LinkTabProps {
  label?: string;
  href?: string;
  selected?: boolean;
}

export interface StyledImageButtonProps {
  url: string,
  title: string,
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export type UpdateUserRequest = {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  startDate?: string;
  phoneNumber?: string;
  locationId?: string;
  isDisabled?: boolean;
};

export type EditUserFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  dateOfBirth: string;
  startDate: string;
  locationId: string;
};

export const USER_ROLE_VALUES = ['teammember', 'manager', 'admin', 'owner'] as const;
export type UserRoleValue = typeof USER_ROLE_VALUES[number];

export type EditUserRoleFormValues = {
  role: UserRoleValue;
};

export type ChangePasswordFormValues = {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
};

export type CreateLocationRequest = {
  name: string;
  addressLine1?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  country?: string;
  phone?: string;
  email?: string;
};

export type UpdateLocationRequest = CreateLocationRequest & {
  id: string;
  isDisabled?: boolean;
};

export type EditLocationFormValues = {
  name: string;
  addressLine1: string;
  city: string;
  province: string;
  postalCode: string;
  country: string;
  phone: string;
  email: string;
  isDisabled: 'true' | 'false';
};

export type CreateLocationFormValues = {
  name: string;
  addressLine1: string;
  city: string;
  province: string;
  postalCode: string;
  country: string;
  phone: string;
  email: string;
};

export type CateringFormValues = {
  groupSize?: 'small' | 'large';
  name?: string;
  email?: string;
  phone?: string;
  numberOfPeople?: string;
  date?: string;
  address?: string;
  allergies?: string;
};